videojs.addLanguage('cs', {
  "Audio Player": "Audio Přehravač",
  "Video Player": "Video Přehravač",
  "Play": "Přehrát",
  "Pause": "Pauza",
  "Replay": "Spustit znovu",
  "Current Time": "Aktuální čas",
  "Duration": "Doba trvání",
  "Remaining Time": "Zbývající čas",
  "Stream Type": "Typ streamu",
  "LIVE": "ŽIVĚ",
  "Loaded": "Načteno",
  "Progress": "Stav",
  "Progress Bar": "Ukazatel průběhu",
  "progress bar timing: currentTime={1} duration={2}": "{1} z {2}",
  "Fullscreen": "Celá obrazovka",
  "Non-Fullscreen": "Běžné zobrazení",
  "Mute": "Ztlumit zvuk",
  "Unmute": "Zapnout zvuk",
  "Playback Rate": "Rychlost přehrávání",
  "Subtitles": "Titulky",
  "subtitles off": "Bez titulků",
  "Captions": "Popisky",
  "captions off": "Popisky vypnuty",
  "Chapters": "Kapitoly",
  "Descriptions": "Popisy",
  "descriptions off": "Bez popisů",
  "Audio Track": "Zvuková stopa",
  "Volume Level": "Hlasitost",
  "You aborted the media playback": "Přehrávání videa bylo přerušeno.",
  "A network error caused the media download to fail part-way.": "Video nemohlo být načteno kvůli chybě v síti.",
  "The media could not be loaded, either because the server or network failed or because the format is not supported.": "Video nemohlo být načteno, buď kvůli chybě serveru, sítě nebo proto, že daný formát není podporován.",
  "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Váš prohlížeč nepodporuje tento formát videa.",
  "No compatible source was found for this media.": "Nevalidní zadaný zdroj videa.",
  "The media is encrypted and we do not have the keys to decrypt it.": "Chyba při dešifrování videa.",
  "Play Video": "Přehrát video",
  "Close": "Zavřit",
  "Close Modal Dialog": "Zavřít okno",
  "Modal Window": "Modální okno",
  "This is a modal window": "Toto je modální okno",
  "This modal can be closed by pressing the Escape key or activating the close button.": "Toto okno se dá zavřít křížkem nebo klávesou Esc.",
  ", opens captions settings dialog": ", otevřít okno pro nastavení popisků",
  ", opens subtitles settings dialog": ", otevřít okno pro nastavení titulků",
  ", opens descriptions settings dialog": ", otevře okno pro nastavení popisků pro nevidomé",
  ", selected": ", vybráno",
  "captions settings": "nastavení popisků",
  "subtitles settings": "nastavení titulků",
  "descriptions settings": "nastavení popisků pro nevidomé",
  "Text": "Titulky",
  "White": "Bílé",
  "Black": "Černé",
  "Red": "Červené",
  "Green": "Zelené",
  "Blue": "Modré",
  "Yellow": "Žluté",
  "Magenta": "Fialové",
  "Cyan": "Azurové",
  "Background": "Pozadí titulků",
  "Window": "Okno",
  "Transparent": "Průhledné",
  "Semi-Transparent": "Poloprůhledné",
  "Opaque": "Neprůhledné",
  "Font Size": "Velikost písma",
  "Text Edge Style": "Okraje písma",
  "None": "Bez okraje",
  "Raised": "Zvýšený",
  "Depressed": "Propadlý",
  "Uniform": "Rovnoměrný",
  "Dropshadow": "Stínovaný",
  "Font Family": "Rodina písma",
  "Proportional Sans-Serif": "Proporcionální bezpatkové",
  "Monospace Sans-Serif": "Monospace bezpatkové",
  "Proportional Serif": "Proporcionální patkové",
  "Monospace Serif": "Monospace patkové",
  "Casual": "Hravé",
  "Script": "Ručně psané",
  "Small Caps": "Malé kapitálky",
  "Reset": "Obnovit",
  "restore all settings to the default values": "Vrátit nastavení do výchozího stavu",
  "Done": "Hotovo",
  "Caption Settings Dialog": "Okno s nastavením titulků",
  "Beginning of dialog window. Escape will cancel and close the window.": "Začátek dialogového okna. Klávesa Esc okno zavře.",
  "End of dialog window.": "Konec dialogového okna.",
  "{1} is loading.": "{1} se načítá."
});